"use client";

import React, { createContext, useContext, useEffect } from "react";

type Theme = "light";

interface ThemeContextType {
  theme: Theme;
  toggleTheme: () => void;
  setTheme: (theme: Theme) => void;
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export function ThemeProvider({ children }: { children: React.ReactNode }) {
  useEffect(() => {
    // Force light mode on mount
    document.documentElement.classList.remove("dark");
    localStorage.removeItem("theme");
  }, []);

  // Always return light theme, no-op functions
  const value: ThemeContextType = {
    theme: "light",
    toggleTheme: () => {}, // No-op: dark mode not implemented
    setTheme: () => {}, // No-op: dark mode not implemented
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }
  return context;
}
